import * as B from '@blueprintjs/core';
import classnames from 'classnames';
import React from 'react';

import cs from 'app/components/Sidebar/styles.module.scss';

export interface SidebarCardProps extends Omit<B.CardProps, 'ref'> {
  /** Open on the map. */
  isFocused?: boolean;
}

export const SidebarCard = React.forwardRef<HTMLDivElement, SidebarCardProps>(
  ({isFocused, className, ...cardProps}, ref) => (
    <B.Card
      ref={ref}
      className={classnames(cs.card, {[cs.cardFocused]: isFocused}, className)}
      {...cardProps}
    />
  )
);
SidebarCard.displayName = 'SidebarCard';

/** Header row of a card: checkbox, type tag, date, trailing controls. */
export const SidebarCardHeader: React.FC<React.PropsWithChildren<{className?: string}>> = ({
  className,
  children,
}) => <div className={classnames(cs.cardHeader, className)}>{children}</div>;

/** Vertical stack of cards with consistent spacing. */
export const SidebarCardList: React.FC<React.PropsWithChildren<{className?: string}>> = ({
  className,
  children,
}) => <div className={classnames(cs.cardList, className)}>{children}</div>;
